const USER_ACTION_TYPES = {
  LOAD_USERS: 'user/LOAD_USERS',
};

export default USER_ACTION_TYPES;
